import { React } from "react";
import "./styles/Members.css";
import "../../components/Toolbar/Toolbar.js";

import ButtonSection from "../../components/ButtonSection/ButtonSection";
import LabDesign from "./LabDesign";
import HumanPractices from "./HumanPractices";
import MathModelling from "./MathModelling";
import Wiki from "./Wiki";
import Finance from "./Finance";

const Members = ({ fontSize }) => {
  const sections = {
    "Lab & Design": <LabDesign />,
    "Human Practices": <HumanPractices />,
    "Math & Modelling": <MathModelling />,
    Wiki: <Wiki />,
    Finance: <Finance />,
  };

  return (
    <div className="page">
      <div className="teamsDiv">
        <h1 style={{ fontSize: `${40 + fontSize}px` }} className="page-title">
          Members
        </h1>
        <ButtonSection sections={sections} />
      </div>
    </div>
  );
};

export default Members;
